<template>
  <HeaderBar />
  <ButtonBackContainer>
    <ButtonBack :fallback="{ name: 'viewCar', params: { id: appointment?.car?.id } }">{{
      t('back')
    }}</ButtonBack>
    <AuditLogButton
      v-if="appointment"
      :entity-type="AuditLogEntityType.WORKSHOP_APPOINTMENT"
      :entity-id="appointment.id"
    />
  </ButtonBackContainer>

  <section class="carvia-container">
    <div v-if="isLoading" class="flex justify-center">
      <Spinner />
    </div>
    <div v-else-if="!appointment" class="text-sm text-hazel-700">
      {{ t('notFound') }}
    </div>
    <WorkshopAppointmentForm
      v-else
      :car="appointment.car"
      :workshop-appointment="appointment"
      @complete="handleComplete"
    />
  </section>
</template>

<script lang="ts" setup>
import { computed, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import HeaderBar from '@/components/headerbar/HeaderBar.vue';
import ButtonBackContainer from '@/components/ButtonBackContainer.vue';
import ButtonBack from '@/components/buttons/ButtonBack.vue';
import Spinner from '@/components/icons/Spinner.vue';
import AuditLogButton from '@/components/audit-log/AuditLogButton.vue';
import { AuditLogEntityType } from '@carvia/ros-client-types';
import WorkshopAppointmentForm from '@/views/vehicle-pool/vehicle-pool-list/components/WorkshopAppointmentForm.vue';
import { useWorkshopAppointment } from '@/queries/use-workshop-appointments';
import { useUiStore } from '@/stores/ui.store';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const uiStore = useUiStore();

const id = computed(() => route.params.id as string);
const { data: appointment, isLoading } = useWorkshopAppointment(id);

watchEffect(() => {
  if (appointment.value?.car?.vehicleType) {
    const { make, model } = appointment.value.car.vehicleType;
    uiStore.setHeaderTitle(
      t('pageTitle'),
      `${make.name} ${model}`,
      appointment.value.car.licencePlate,
    );
  } else {
    uiStore.setHeaderTitle(t('pageTitle'));
  }
});

const handleComplete = async () => {
  if (appointment.value?.car?.id) {
    await router.push({ name: 'editCar', params: { id: appointment.value.car.id } });
  } else {
    router.back();
  }
};
</script>

<i18n lang="json">
{
  "en": {
    "pageTitle": "Workshop appointment",
    "back": "Back",
    "notFound": "Workshop appointment not found."
  },
  "de": {
    "pageTitle": "Werkstatttermin",
    "back": "Zurück",
    "notFound": "Werkstatttermin nicht gefunden."
  }
}
</i18n>
